













import {Vue, Component, Prop, Watch } from 'vue-property-decorator';

import UserSelectSearch from "./fragments/search/UserSelectSearch.vue";
import UserSelectListBox from "./fragments/list-box/UserSelectListBox.vue";
import DefaultWrapper from "./wrappers/DefaultWrapper.vue"

import { UserSelectService } from "./helpers/UserSelectService"
import { RepositoryFabric } from '@api/repositories/RepositoryFabric';
import { UserRepository } from '@api/repositories/UserRepository';
import { UserProfile } from '@api/models/UserProfile';
import { groupFilter } from '@api/helpers/groupFilter';
import { declOfSum } from '@common/WordHelpers';

@Component({
    components: {
        UserSelectSearch, UserSelectListBox, DefaultWrapper
    }
})
export default class UserSelect extends Vue {

    keyword = "";
    service: UserSelectService | null = null;
    profilesList: UserProfile[] = [];
    count = 0;

    @Prop({ default: "default-wrapper" }) wrapperName: string;
    @Prop({ default: {x: 7 , y: 0} }) tailPosition: {x: number; y: number};
    @Prop({ default: true }) filterOwnProfile: boolean

    mounted() {
        this.service = new UserSelectService(
            this.$repositories.get(RepositoryFabric.USER) as UserRepository,
            this.$store,
            this.groupFilter,
            this.eventId,
            this.userId
        );

        this.watchKeyword("", true);
    }

    @Watch('keyword')
    async watchKeyword(value: string, force = false) {

        force = typeof force === "boolean" ? force : false;

        const result = await this.service?.getProfiles(value, force, this.filterOwnProfile);

        if(result) {
            const { profiles, count } = result;

            this.profilesList = profiles;
            this.count = count;
        }
    }

    private get eventId() {
        return this.$store.state.events.selected;
    }

    private get groupFilter() {
        return groupFilter(this.participantsGroupIds);
    }

    private get participantsGroupIds() {
		const params = this.$store.getters['events/selectedEventViewParam']('participants', null);
        return params?.groupIds || this.$store.state.session.profile?.groupIds || [];
	}

    private get userId() {
        return this.$store.state.session.userId;
    }

    /**
     * get local string
     */
    getLS(key: string) {
        return this.$t(key).toString();
    }

    get countString() {

        const participants = declOfSum(this.count, this.$t('participants.participants').toString().toLowerCase().split(","));
        const found = declOfSum(this.count, this.$t('participants.found').toString().split(","));


        return  this.$t("participants.foundCount", { found: found, count: this.count, participants: participants })
    }

    beforeDestroy() {
        this.profilesList = []
    }
}
